import React, { useState, useCallback } from 'react';

import { StyledCheckbox } from 'components/UI/StyledCheckbox';
import classNames from 'classnames';

const COLLAPSE_LIST_AT = 8;

type Option = {
  id: string;
  label: string;
  disabled: boolean;
};

type Props = {
  name: string;
  label: string;
  options: Option[];
  selected: string[];
  onChange: (ids: string[]) => void;
  className?: string;
};

export const CheckboxGroup: React.FC<Props> = ({
  selected,
  onChange,
  label,
  options,
  name,
  className,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggle = useCallback((): void => setIsOpen(!isOpen), [setIsOpen, isOpen]);

  return (
    <aside className={classNames(className, 'checkbox-group', { open: isOpen })}>
      <h1 className='checkbox-group__label lh-1 mb-1'>{label}</h1>

      {options.map((option, index) => {
        return (
          <StyledCheckbox
            key={option.id}
            className={classNames('checkbox-group__option', { hidden: COLLAPSE_LIST_AT < index })}
            name={name}
            label={option.label}
            value={option.id}
            checked={selected.includes(option.id)}
            disabled={option.disabled}
            onChange={(checked, value) => {
              onChange(
                checked && value
                  ? [...selected, value]
                  : selected.filter((item) => item !== option.id),
              );
            }}
          />
        );
      })}
      <button className='collapse--button' onClick={toggle}>
        {isOpen ? 'Less' : 'More'}
      </button>
    </aside>
  );
};
